module.exports = __webpack_public_path__ + "static/media/beach-boat-bg.953a3e41.jpg";